<template>
  <component
    :is="component"
    :class="[ 'banner-details', {
      '-link': component !== 'div',
      '-result': isResult
    } ]"
    :href="href"
    :target="target"
    :to="to"
    data-cy="banner-details"
  >
    <c-card
      v-if="isResult"
      class="card"
      :style="{ backgroundImage: `url(${banner.image})` }"
      @click.native="handleAnalytics('Banners')"
    />

    <picture
      v-else
      class="content"
    >
      <source
        :srcset="banner.image"
        media="(min-width: 769px)"
      />
      <img
        class="image"
        :src="banner.image_secondary"
        :alt="banner.name"
        @load="change"
        ref="image"
        @click="handleAnalytics('banner-principal')"
      />
    </picture>
  </component>
</template>

<script>
// import Slugify from '@/helpers/slugify'

export default {
  props: {
    banner: {
      type: Object,
      required: true
    },
    type: String,
    isResult: Boolean
  },
  computed: {
    component () {
      const { link, partner, campaign, showcase, vidalink, only_tagged } = this.banner

      if (showcase && !this.isShowcase) {
        return 'router-link'
      } else if (campaign || partner || +vidalink === 1 || +only_tagged === 1) {
        return 'router-link'
      } else {
        return link ? 'a' : 'div'
      }
    },

    to () {
      const { showcase: tag = '', vidalink, only_tagged, tags } = this.banner
      if (+vidalink === 1) {
        return '/cartao-farmacia'
      }
      if (+only_tagged === 1) {
        const onlyTag = tags && tags.length > 0 ? tags[0] : ''
        return {
          name: 'Campanhas',
          query: { tag: onlyTag }
        }
      }
      if (!this.isShowcase && !!tag) {
        return {
          name: 'Vitrine',
          params: { tag }
          // query: {
          //   utm_source: 'clube',
          //   utm_campaign: Slugify(this.banner.name),
          //   utm_medium: this.banner.type === 1 ? 'resultado' : 'home'
          // }
        }
      }

      if (this.component !== 'router-link') return ''

      const { partner: p, campaign: c } = this.banner

      const campaignSlug = (c || {}).slug
      const partner = (p || {}).slug

      const data = campaignSlug
        ? {
          name: 'Detalhes da campanha',
          params: { campaignSlug }
          // query: {
          //   utm_source: 'clube',
          //   utm_campaign: Slugify(this.banner.name),
          //   utm_medium: this.banner.type === 1 ? 'resultado' : 'home'
          // }
        } : {
          name: 'Campanhas'
          // query: {
          //   partner,
          //   utm_source: 'clube',
          //   utm_campaign: Slugify(this.banner.name),
          //   utm_medium: this.banner.type === 1 ? 'resultado' : 'home'
          // }
        }

      const to = {
        ...this.$route,
        ...data
      }

      return to
    },

    href () {
      // const prefix = this.banner.link.match(/\?/g) ? '&' : '?'
      return this.component === 'a' && this.banner.link
      // return this.component === 'a' && this.banner.link + prefix + this.utmParams
    },

    // utmParams () {
    //   return `utm_source=clube&utm_campaign=${Slugify(this.banner.name)}&utm_medium=${this.banner.type === 1 ? 'resultado' : 'home'}`
    // },

    target () {
      return this.component === 'a' && '_blank'
    },

    isShowcase () {
      return this.$route.meta.showcase
    }
  },
  methods: {
    change () {
      const { image } = this.$refs
      this.$nextTick(() => {
        if (image) image.style.backgroundImage = `url('${image.currentSrc || image.src}')`
      })
      // if (image) image.style.backgroundImage = `url('${image.currentSrc || image.src}')`
    },

    handleAnalytics (name) {
      if (this.banner) {
        const type = this.type || 'Resultados'
        const partner = this.banner.partner ? this.banner.partner.slug : null
        const campaign = this.banner.campaign ? this.banner.campaign.slug : ''
        window.dataLayer.push({
          event: name,
          banner_id: this.banner.id,
          partner_slug: partner,
          campaign_slug: campaign,
          tipo_banner: type,
          nome_banner: this.banner.name
        })
      }
    }
  }
}
</script>

<style lang="scss">
@import '~@style/reference';

.banner-details {
  &:not(.-result) {
    @include desktop {
      display: block;
      height: 230px;
    }

    &.-link { cursor: pointer; }

    & > .content {
      width: 100%;
      height: 100%;

      & > .image {
        box-sizing: border-box;
        display: block;
        width: 100vw;
        height: 100%;

        @include desktop {
          background-position: center center;
          background-repeat: no-repeat;
          background-size: cover;
          padding: 115px 50vw;
        }
      }
    }
  }

  &.-result > .card {
    position: relative;
    min-height: 150px;
    height: 100%;
    cursor: pointer;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: right;

    @include desktop {
      transition: all .3s ease;

      &:hover {
        position: relative;
        box-shadow: 0px 0px 21px 0px rgba(18, 30, 72, 0.5);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Banner/BannerDetails.vue